let __resolution = null;
const isInBrowserContext = () => {
    // not true when running tests
    return typeof window !== 'undefined';
};
export function getScreenResolution() {
    if (isInBrowserContext()) {
        const width = window.screen.width;
        const height = window.screen.height;
        __resolution = `${Math.min(width, height)}x${Math.max(width, height)}`;
    }
    else {
        __resolution = 'N/A';
    }
    return __resolution;
}
export function getViewportResolution() {
    if (isInBrowserContext()) {
        const width = window.innerWidth;
        const height = window.innerHeight;
        return `${Math.min(width, height)}x${Math.max(width, height)}`;
    }
    return 'N/A';
}
export function getViewportWidth() {
    return isInBrowserContext() ? window.innerWidth : null;
}
export function getViewportHeight() {
    return isInBrowserContext() ? window.innerHeight : null;
}
//# sourceMappingURL=screen.utils.js.map